<template>
  <div class="textarea-field-response">
    <div class="field-header">
      <h3 class="field-label">
        {{ field.label }}
        <span v-if="field.required" class="required-indicator">*</span>
      </h3>
    </div>

    <div v-if="field.description" class="field-description">
      {{ field.description }}
    </div>

    <v-textarea
      v-model="localResponse.textValue"
      outlined
      :placeholder="field.hint || 'Enter text...'"
      :rules="getValidationRules()"
      auto-grow
      rows="4"
      @change="updateResponse"
      :readonly="disabled"
    ></v-textarea>

    <v-textarea
      v-model="localResponse.comment"
      outlined
      dense
      label="Comment (Optional)"
      placeholder="Add any additional comments here..."
      rows="2"
      auto-grow
      :readonly="disabled"
      @change="updateResponse"
    ></v-textarea>
  </div>
</template>

<script>
//@ts-nocheck
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Field } from '@/shared/types/aperTemplate';
import { ResponseDTO } from '@/shared/apis/aper/aperEvaluations';

@Component
export default class TextareaFieldResponse extends Vue {
  @Prop({ type: Object, required: true }) field;
  @Prop({ type: Object, required: false }) response;
  @Prop({ type: Boolean, required: false }) disabled;

  localResponse = {
    fieldId: 0,
    textValue: '',
    comment: ''
  };

  created() {
    this.initializeResponse();
  }

  @Watch('response')
  onResponseChange() {
    this.initializeResponse();
  }

  initializeResponse() {
    if (this.response) {
      this.localResponse = { ...this.response };
    } else {
      this.localResponse = {
        fieldId: this.field.id || 0,
        textValue: '',
        comment: ''
      };
    }
  }

  getValidationRules() {
    const rules = [];

    if (this.field.required) {
      rules.push((v) => !!v || `${this.field.label} is required`);
    }

    if (this.field.minLength !== undefined) {
      rules.push((v) => !v || v.length >= this.field.minLength ||
        `Minimum length is ${this.field.minLength} characters`);
    }

    if (this.field.maxLength !== undefined) {
      rules.push((v) => !v || v.length <= this.field.maxLength ||
        `Maximum length is ${this.field.maxLength} characters`);
    }

    return rules;
  }

  updateResponse() {
    this.$emit('update:response', this.localResponse);
  }
}
</script>

<style scoped>
.textarea-field-response {
  width: 100%;
}

.field-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.field-label {
  font-size: 1rem;
  font-weight: 500;
  color: #333;
  margin: 0 0 4px 0;
}

.required-indicator {
  color: #f44336;
  margin-left: 4px;
}

.field-description {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 12px;
}
</style>
